import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center items-center my-8 lg:flex-row lg:justify-start lg:my-10 pb-6 border-b border-gray-200" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-50 rounded-[.875rem] p-7" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/cookie.svg",
    class: "w-[2.1875rem] h-[2.1875rem] lg:w-[4.125rem] lg:h-[4.125rem]"
  })
], -1)
const _hoisted_3 = { class: "ml-4 flex flex-col justify-center items-center lg:items-start" }
const _hoisted_4 = { class: "flex flex-col lg:flex-row items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium text-2xl leading-8 lg:text-2xl lg:leading-10 text-gray-900" }, " ผลลัพธ์การสแกน ", -1)
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "text-gray-500 font-normal text-xl leading-6 lg:text-xl lg:leading-7 mt-4" }
const _hoisted_8 = { class: "flex mr-3" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "mt-3 md:mt-0" }
const _hoisted_11 = { class: "mt-2.5 text-center lg:w-full" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "mr-2" }, "ดูเพิ่มเติม", -1)
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "mt-14 lg:mt-10" }
const _hoisted_15 = { class: "border-b border-gray-200 py-5" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-900 font-normal text-base leading-6 lg:font-medium lg:leading-7" }, "URL Scanned:", -1)
const _hoisted_17 = { class: "text-gray-500 font-normal text-base leading-6 lg:leading-7 ml-2" }
const _hoisted_18 = { class: "border-b border-gray-200 py-5" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-900 font-normal text-base leading-6 lg:font-medium lg:leading-7" }, "หน้าทั้งหมดที่สแกน", -1)
const _hoisted_20 = { class: "text-white bg-[#2B3BA6] font-normal text-base leading-6 lg:font-medium lg:text-xl lg:leading-7 px-2 py-1 rounded ml-2" }
const _hoisted_21 = { class: "border-b border-gray-200 py-5" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-900 font-normal text-base leading-6 lg:font-medium lg:leading-7" }, "คุกกี้ทั้งหมด", -1)
const _hoisted_23 = { class: "text-white bg-[#F79009] font-normal text-base leading-6 lg:font-medium lg:text-xl lg:leading-7 px-2 py-1 rounded ml-2" }
const _hoisted_24 = { class: "border-b border-gray-200 py-5" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-900 font-normal text-base leading-6 lg:font-medium lg:leading-7" }, "คุกกี้ในส่วนการตลาด", -1)
const _hoisted_26 = { class: "text-white bg-[#F26634] font-normal text-base leading-6 lg:font-medium lg:text-xl lg:leading-7 px-2 py-1 rounded ml-2" }
const _hoisted_27 = { class: "border-b border-gray-200 py-5" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-900 font-normal text-base leading-6 lg:font-medium lg:leading-7" }, "คุกกี้ในส่วนวิเคราะห์", -1)
const _hoisted_29 = { class: "text-white bg-[#F26634] font-normal text-base leading-6 lg:font-medium lg:text-xl lg:leading-7 px-2 py-1 rounded ml-2" }
const _hoisted_30 = { class: "border-b border-gray-200 py-5" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-900 font-normal text-base leading-6 lg:font-medium lg:leading-7" }, "คุกกี้ในส่วนฟังก์ชัน", -1)
const _hoisted_32 = { class: "text-white bg-[#2B3BA6] font-normal text-base leading-6 lg:font-medium lg:text-xl lg:leading-7 px-2 py-1 rounded ml-2" }
const _hoisted_33 = {
  key: 0,
  class: "flex flex-col items-center justify-center text-[#101828] pt-10 pb-6 px-4 md:px-6 xl:px-9 border border-[#EAECF0] bg-[#F9FAFB] rounded-lg mt-6"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-base md:text-2xl leading-8 text-center text-gray-600" }, " ตามกฎหมาย GDPR/PDPA เว็บไซต์ส่วนใหญ่มักละเมิดกฎหมาย 3 มาตรานี้ ", -1)
const _hoisted_35 = { class: "flex flex-col w-full" }
const _hoisted_36 = { class: "flex mt-6 justify-center" }
const _hoisted_37 = ["src"]
const _hoisted_38 = { class: "font-medium text-sm md:text-base leading-6 ml-4 text-[#3A4EBC] w-[47.725rem]" }
const _hoisted_39 = { class: "flex mt-2 md:mt-4 justify-center" }
const _hoisted_40 = ["src"]
const _hoisted_41 = { class: "font-medium text-sm md:text-base leading-6 ml-4 text-[#3A4EBC] w-[47.725rem]" }
const _hoisted_42 = { class: "flex mt-2 md:mt-4 justify-center" }
const _hoisted_43 = ["src"]
const _hoisted_44 = { class: "font-medium text-sm md:text-base leading-6 ml-4 text-[#3A4EBC] w-[47.725rem]" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium text-base md:text-xl leading-7 mt-6 text-center text-[#475467]" }, " เว็บไซต์ที่คุณให้เราตรวจสอบอาจผิด 1 ใน 3 มาตรานี้หรือมาตราอื่นๆ เพื่อปฏิบัติตาม GDPR/PDPA ให้ถูกต้องมากขึ้น ", -1)
const _hoisted_46 = { class: "flex flex-col md:flex-row items-center mt-6" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm leading-5 font-semibold" }, [
  /*#__PURE__*/_createTextVNode(" เพียง "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-[#F26634] text-2xl leading-8 font-bold mx-1" }, " 165.83 บาท "),
  /*#__PURE__*/_createTextVNode(" ต่อเดือน ")
], -1)
const _hoisted_48 = ["src"]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs md:text-base leading-5 md:leading-7 font-medium text-white mt-1 ml-2 break-words" }, " สมัครใช้งาน ", -1)
const _hoisted_50 = { class: "cookiesTableContainer" }
const _hoisted_51 = {
  vertical: "",
  size: "large",
  class: "reporttable table"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Cookie key"),
    /*#__PURE__*/_createElementVNode("th", null, "Cookie Category"),
    /*#__PURE__*/_createElementVNode("th", null, "Domain"),
    /*#__PURE__*/_createElementVNode("th", null, "Path"),
    /*#__PURE__*/_createElementVNode("th", null, "Cookie type"),
    /*#__PURE__*/_createElementVNode("th", null, "Expiration"),
    /*#__PURE__*/_createElementVNode("th", null, "Description")
  ])
], -1)
const _hoisted_53 = { "data-label": "Cookie key" }
const _hoisted_54 = { "data-label": "Cookie Category" }
const _hoisted_55 = { "data-label": "Domain" }
const _hoisted_56 = { "data-label": "Path" }
const _hoisted_57 = { "data-label": "Cookie type" }
const _hoisted_58 = { "data-label": "Expiration" }
const _hoisted_59 = {
  "data-label": "Description",
  class: "repdesc"
}
const _hoisted_60 = {
  key: 1,
  class: "main-modal fixed w-full inset-0 z-50 overflow-hidden flex justify-center items-center backdrop-blur-sm",
  style: {"background":"rgba(0, 0, 0, 0.25)"}
}
const _hoisted_61 = { class: "border border-blue-500 modal-container bg-white max-w-[22.5rem] md:max-w-[25.625rem] mx-auto rounded-lg shadow-lg z-50 overflow-y-auto" }
const _hoisted_62 = { class: "modal-content" }
const _hoisted_63 = /*#__PURE__*/_createStaticVNode("<div class=\"px-4 pt-6 pb-4 border-b border-gray-200\"><div class=\"flex justify-start items-center\"><img src=\"/images/SableLogo.png\" class=\"w-[1.5rem] h-[1.5rem]\"><div class=\"text-base font-semibold ml-3\">Cookie Eye</div></div><div class=\"mt-8\"><div class=\"font-semibold text-lg leading-[1.875rem]\"> รับรายงานผลการสแกนเว็บไซต์ของคุณ </div><div class=\"text-gray-500 font-normal text-xs leading-[1.125rem]\"> กรอกข้อมูลเพื่อรับรายงานผลการสแกนเว็บไซต์ของคุณ </div></div></div>", 1)
const _hoisted_64 = { class: "px-4 pt-6 pb-2" }
const _hoisted_65 = { class: "flex justify-between items-center" }
const _hoisted_66 = { class: "w-1/2 flex flex-col justify-center pr-2" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium text-xs leading-5 mb-1" }, [
  /*#__PURE__*/_createTextVNode(" ชื่อ "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1)
const _hoisted_68 = { class: "w-1/2 flex flex-col justify-center pl-2" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium text-xs leading-5 mb-1" }, [
  /*#__PURE__*/_createTextVNode(" นามสกุล "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1)
const _hoisted_70 = { class: "w-full flex flex-col justify-center mt-4" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium text-xs leading-5 mb-1" }, [
  /*#__PURE__*/_createTextVNode(" อีเมล "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500 text-xs" }, "*")
], -1)
const _hoisted_72 = {
  key: 0,
  class: "text-red-500 text-xs"
}
const _hoisted_73 = { class: "p-4" }
const _hoisted_74 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.cookies)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["relative", { 'overflow-hidden': _ctx.isShowModal }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("a", {
                href: _ctx.url,
                target: "_blank",
                class: "font-normal text-2xl leading-8 lg:text-2xl lg:leading-10 text-[#F26634] lg:ml-2"
              }, _toDisplayString(_ctx.url), 9, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, " สร้างเมื่อ " + _toDisplayString(_ctx.formatDate(_ctx.dateGenerate)), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", {
            class: _normalizeClass(["border-2 rounded-lg py-4 px-6 flex flex-col md:flex-row", [
          `border-[${_ctx.bannerData[_ctx.typeOfResult]['border-color']}]`,
          `bg-[${_ctx.bannerData[_ctx.typeOfResult]['bg-color']}]`,
        ]])
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("img", {
                src: '/images/' + _ctx.typeOfResult + '.svg',
                class: "w-[1.4375rem] h-[1.4375rem]"
              }, null, 8, _hoisted_9)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", {
                class: _normalizeClass(["text-lg font-semibold leading-6", [`text-[${_ctx.bannerData[_ctx.typeOfResult]['text-color']}]`]])
              }, _toDisplayString(_ctx.bannerData[_ctx.typeOfResult].header), 3),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", {
                  class: _normalizeClass(["text-base font-normal leading-6 w-full text-left md:text-center", [`text-[${_ctx.bannerData[_ctx.typeOfResult]['text-color']}]`]])
                }, _toDisplayString(_ctx.bannerData[_ctx.typeOfResult].description), 3)
              ]),
              _createElementVNode("span", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openLink('https://sable.asia/sable-consent/'))),
                class: _normalizeClass(["flex font-semibold text-sm mt-3 cursor-pointer w-fit items-center", [`text-[${_ctx.bannerData[_ctx.typeOfResult]['text-color']}]`]])
              }, [
                _hoisted_12,
                _createElementVNode("div", null, [
                  _createElementVNode("img", {
                    src: '/images/arrow_right_' + _ctx.typeOfResult + '.svg',
                    class: "w-[1.3rem] h-[1.2rem]"
                  }, null, 8, _hoisted_13)
                ])
              ], 2)
            ])
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.url), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.totalPageScanned), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.totalCookiesFound), 1)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.totalMarketingCookiesFound), 1)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.totalAnalyticsCookiesFound), 1)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.totalFunctionalCookiesFound), 1)
          ])
        ]),
        (_ctx.typeOfResult === 'dangerous' || _ctx.typeOfResult === 'warning')
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("img", {
                    src: '/images/1.svg',
                    class: "w-[2rem] h-[2rem]"
                  }, null, 8, _hoisted_37),
                  _createElementVNode("span", _hoisted_38, [
                    _createTextVNode(" ข้อมูลส่วนบุคคลถูกเก็บรวบรวมทั้งทางตรงและทางอ้อม โดยยังไม่ได้รับความยินยอมจากเจ้าของข้อมูล ตัวอย่างเช่น การใช้งานเครื่องมือ Analytics ก่อนขอความยินยอมจากผู้ใช้งาน "),
                    _createElementVNode("span", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openLink('https://lawman.in.th/9464/pdpa-มาตรา-24/'))),
                      class: "underline cursor-pointer"
                    }, " (มาตรา 24) ")
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("img", {
                    src: '/images/2.svg',
                    class: "w-[2rem] h-[2rem]"
                  }, null, 8, _hoisted_40),
                  _createElementVNode("span", _hoisted_41, [
                    _createTextVNode(" การใช้ข้อมูลส่วนบุคคลโดยไม่ได้รับความยินยอมจากเจ้าของข้อมูล เช่น การนำข้อมูลที่ได้ไปใช้ในการทำการตลาด หรือใช้งาน Facebook Pixel เพื่อการโฆษณาก่อนการได้รับความยินยอมจากผู้ใช้ "),
                    _createElementVNode("span", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openLink('https://lawman.in.th/9466/pdpa-มาตรา-27/'))),
                      target: "_blank",
                      class: "underline cursor-pointer"
                    }, " (มาตรา 27) ")
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("img", {
                    src: '/images/3.svg',
                    class: "w-[2rem] h-[2rem]"
                  }, null, 8, _hoisted_43),
                  _createElementVNode("span", _hoisted_44, [
                    _createTextVNode(" การเปิดเผยแพร่ข้อมูลส่วนบุคคลให้กับบุคคลที่สามหรือการโอนข้อมูลข้ามชาติไปยังประเทศที่ไม่มีมาตรฐานการคุ้มครองข้อมูลส่วนบุคคลที่เพียงพอ ตัวอย่างเช่น การเก็บหรือส่งต่อข้อมูลไปยังเซิร์ฟเวอร์ที่ตั้งอยู่ในสหรัฐอเมริกา "),
                    _createElementVNode("span", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openLink('https://lawman.in.th/9468/pdpa-มาตรา-28/'))),
                      class: "underline cursor-pointer"
                    }, " (มาตรา 28) ")
                  ])
                ])
              ]),
              _hoisted_45,
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _createElementVNode("a", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openLink('https://sable.asia/sable-consent/'))),
                  class: "bg-[#4D7EE0] hover:bg-[#4775D2] flex-row items-center justify-center md:justify-start rounded px-2 md:px-4 py-2.5 flex item-center mt-4 md:mt-0 md:ml-6 w-full md:w-auto cursor-pointer"
                }, [
                  _createElementVNode("img", {
                    src: '/images/protect.svg',
                    class: "w-[1.125rem] h-[1.375rem] self-center"
                  }, null, 8, _hoisted_48),
                  _hoisted_49
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("table", _hoisted_51, [
            _hoisted_52,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cookies, (entry, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_53, _toDisplayString(entry.name), 1),
                  _createElementVNode("td", _hoisted_54, _toDisplayString(entry.detail["Category"] || "Unknown"), 1),
                  _createElementVNode("td", _hoisted_55, _toDisplayString(entry.domain), 1),
                  _createElementVNode("td", _hoisted_56, _toDisplayString(entry.path), 1),
                  _createElementVNode("td", _hoisted_57, _toDisplayString(entry.detail.cookieType), 1),
                  _createElementVNode("td", _hoisted_58, _toDisplayString(entry.detail.expiration), 1),
                  _createElementVNode("td", _hoisted_59, _toDisplayString(entry.detail.Description ?? "Unknown"), 1)
                ]))
              }), 128))
            ])
          ])
        ]),
        (_ctx.isShowModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, [
                  _hoisted_63,
                  _createElementVNode("form", {
                    name: "basic_contact",
                    onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveContact && _ctx.saveContact(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, [
                          _hoisted_67,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "firstName",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.firstName) = $event)),
                            placeholder: "ระบุชื่อ",
                            class: "font-normal text-sm leading-5 text-gray-900 placeholder:text-gray-200 focus:placeholder:text-transparent border border-gray-200 rounded p-2 hover:border-[#F26634] outline-none focus:border-[#F26634] caret-[#F26634]"
                          }, null, 512), [
                            [_vModelText, _ctx.firstName]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_68, [
                          _hoisted_69,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "lastName",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.lastName) = $event)),
                            placeholder: "ระบุนามสกุล",
                            class: "font-normal text-sm leading-5 text-gray-900 placeholder:text-gray-200 focus:placeholder:text-transparent border border-gray-200 rounded p-2 hover:border-[#F26634] outline-none focus:border-[#F26634] caret-[#F26634]"
                          }, null, 512), [
                            [_vModelText, _ctx.lastName]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_70, [
                        _hoisted_71,
                        _withDirectives(_createElementVNode("input", {
                          type: "email",
                          name: "email",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.email) = $event)),
                          placeholder: "you@company.com",
                          class: "font-normal text-sm leading-5 text-gray-900 placeholder:text-gray-200 focus:placeholder:text-transparent border border-gray-200 rounded p-2 hover:border-[#F26634] outline-none focus:border-[#F26634] caret-[#F26634]"
                        }, null, 512), [
                          [_vModelText, _ctx.email]
                        ]),
                        (_ctx.emailError !== '')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString(_ctx.emailError), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("button", {
                        type: "submit",
                        class: _normalizeClass(["flex items-center justify-center rounded-lg py-2 max-h-9 w-full", [
                  _ctx.disableButton
                    ? 'bg-gray-200 cursor-not-allowed'
                    : 'bg-[#F26634] cursor-pointer',
                ]]),
                        disabled: _ctx.disableButton
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["font-medium text-sm leading-5", [
                    _ctx.disableButton
                      ? 'bg-gray-200 text-gray-400'
                      : 'bg-[#F26634] text-white',
                  ]])
                        }, " ส่ง ", 2)
                      ], 10, _hoisted_74)
                    ])
                  ], 32)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}